import React from "react";

import '../styles/app-feature.css';

export default function({ image, title, children }) {
	return <div className='app-feature'>
		<img src={image} alt='app-feature image'/>
        <h3>{title}</h3>
        <p>{children}</p>
	</div>
}